import React, { Suspense } from "react";
import StudentLayout from "../../layout/StudentLayout";
import { Outlet } from "react-router-dom";
import AuthGuard from "../../layout/auth-guard";

const Fallback = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    {/* <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div> */}
  </div>
);

const SplashScreenStudent = () => {
  return (
    <AuthGuard>
      <StudentLayout>
        <Suspense fallback={<Fallback />}>
          <Outlet />
        </Suspense>
      </StudentLayout>
    </AuthGuard>
  );
};

export default SplashScreenStudent;
